"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = exports.AddressType = void 0;
var Buffer = require('buffer/').Buffer;
var utils_1 = require("./utils");
var AddressType;
(function (AddressType) {
    AddressType["BOX"] = "BOX";
    AddressType["SIGN"] = "SIGN";
    AddressType["KX"] = "KX";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var Address = /** @class */ (function () {
    function Address(_a) {
        var identity = _a.identity, key = _a.key, publicKey = _a.publicKey, privateKey = _a.privateKey, type = _a.type, path = _a.path, wallet = _a.wallet;
        this.identity = identity;
        this.key = key;
        this.publicKey = publicKey;
        this.privateKey = privateKey;
        this.type = type;
        this.path = path;
        this.wallet = wallet;
    }
    Address.prototype.getAddressInfo = function () {
        return {
            addressPath: this.path,
            addressKey: Buffer.from(this.publicKey).toString('base64'),
        };
    };
    Address.prototype.secretBoxEncrypt = function (_a) {
        var nonce = _a.nonce, message = _a.message;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.type !== AddressType.BOX) {
                            throw new Error('The address must be of type BOX');
                        }
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_secretbox_easy(message, nonce, this.key)];
                }
            });
        });
    };
    Address.prototype.secretBoxDecrypt = function (_a) {
        var nonce = _a.nonce, box = _a.box;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.type !== AddressType.BOX) {
                            throw new Error('The address must be of type BOX');
                        }
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_secretbox_open_easy(box, nonce, this.key)];
                }
            });
        });
    };
    Address.prototype.boxEncrypt = function (_a) {
        var recipientPublicKey = _a.recipientPublicKey, nonce = _a.nonce, message = _a.message;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.type !== AddressType.BOX) {
                            throw new Error('The address must be of type BOX');
                        }
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_box_easy(message, nonce, recipientPublicKey, this.privateKey)];
                }
            });
        });
    };
    Address.prototype.boxDecrypt = function (_a) {
        var senderPublicKey = _a.senderPublicKey, nonce = _a.nonce, box = _a.box;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.type !== AddressType.BOX) {
                            throw new Error('The address must be of type BOX');
                        }
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_box_open_easy(box, nonce, senderPublicKey, this.privateKey)];
                }
            });
        });
    };
    Address.prototype.sign = function (_a) {
        var toBeSigned = _a.toBeSigned;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.type !== AddressType.SIGN) {
                            throw new Error('The address must be of type SIGN');
                        }
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_sign_detached(toBeSigned, this.privateKey)];
                }
            });
        });
    };
    Address.verify = function (_a) {
        var payload = _a.payload, signature = _a.signature, publicKey = _a.publicKey;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_sign_verify_detached(signature, payload, publicKey)];
                }
            });
        });
    };
    Address.nonce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _a.sent();
                        return [2 /*return*/, sodium.randombytes_buf(sodium.crypto_box_NONCEBYTES)];
                }
            });
        });
    };
    return Address;
}());
exports.Address = Address;
